// Borrowed from https://github.com/jasonsalzman/react-add-to-calendar.

import React from "react";

import helpersClass from "./helpers";
const helpers = new helpersClass();

import {translation} from 'Services/TranslationHelpers';

export default class AddToCalendar extends React.Component {

	/**
	 * @var listItems
	 */
	listItems = [
		{ apple: "Apple Calendar" },
		{ google: "Google" },
		{ outlook: "Outlook" },
		{ outlookcom: "Outlook.com" }
	]

	/**
	 * @var state
	 */
	state = {
		isCrappyIE: false
	};

    /**
     * @method componentWillMount
     */
    componentWillMount = async () => {
		// polyfill for startsWith to fix IE bug
		if (!String.prototype.startsWith) {
			String.prototype.startsWith = function(searchString, position) {
				position = position || 0;
				return this.indexOf(searchString, position) === position;
			};
		}

		let isCrappyIE = false;

		if (
			typeof window !== "undefined" &&
			window.navigator.msSaveOrOpenBlob &&
			window.Blob
		) {
			isCrappyIE = true;
		}

		this.setState({ isCrappyIE: isCrappyIE });
    }

	/**
	 * @method handleDropdownLinkClick
	 * @param {Event} e
	 */
	handleDropdownLinkClick(e) {
		e.preventDefault();

		let url = e.currentTarget.getAttribute("href");

		if (!helpers.isMobile() && (url.startsWith("data") || url.startsWith("BEGIN"))) {
			
			let filename = this.props.filename + ".ics";
			let blob = new Blob([url], { type: "text/calendar;charset=utf-8" });

			if (this.state.isCrappyIE) {
				window.navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				/****************************************************************
				// many browsers do not properly support downloading data URIs
				// (even with "download" attribute in use) so this solution
				// ensures the event will download cross-browser
				****************************************************************/
				let link = document.createElement("a");
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute("download", filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		} else {
			window.open(url, "_blank");
		}
	}

	/**
	 * @method render
	 * @return {JSX.Element}
	 */
	render() {
		return (
			<div className="flex flex-col text-center">
				<p className="mb-4 font-bold">
					{translation('agenda', 'select_format')}
				</p>
				<p className="mb-4 font-bold text-sm">
					{translation('agenda', 'add_to_calendar_instructions')}
				</p>

				{this.renderDropdown()}
			</div>
		);
	}

	/**
	 * @method renderDropdown
	 * @return {JSX.Element}
	 */
	renderDropdown() {
		const {event} = this.props;
		const {isCrappyIE} = this.state;

		let items = this.listItems.map(listItem => {
			let currentItem = Object.keys(listItem)[0];
			let currentLabel = listItem[currentItem];			

			let currentIcon = currentItem === "outlook" || currentItem === "outlookcom" ? "windows" : currentItem;
			let icon = <i className={"fa fa-" + currentIcon} />;

			return (
				<a
					className="w-full lg:w-1/2 mx-auto my-2 bg-gray-300 uppercase
						rounded-full shadow-sm py-2 px-4 text-black text-sm font-bold hover:bg-gray-500"
					onClick={(e) => this.handleDropdownLinkClick(e)}
					href={helpers.buildUrl(event, currentItem, isCrappyIE)}
					target="_blank"
					key={helpers.getRandomKey()}
				>
					{icon}
					{currentLabel}
				</a>
			);
		});

		return (
			<>
				{items}
			</>
		);
	}
}